module.exports = __webpack_public_path__ + "img/videoPoster4.538ccb13.jpg";